/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export function createChainedFunction<Args extends any[], This>(
	...funcs: Array<(this: This, ...args: Args) => any>
): (this: This, ...args: Args) => void {
	return funcs.reduce(
		(acc, func) => {
			if (func == null) {
				return acc;
			}

			return function chainedFunction(...args) {
				acc.apply(this, args);
				func.apply(this, args);
			};
		},
		() => {}
	);
}
